import React, { lazy, Suspense } from 'react';
import HeroSlider from '../components/HeroSlider';
import DeferredSection from '../components/DeferredSection';
import {
  CategorySkeleton,
  ProductGridSkeleton,
  SectionSkeleton,
  FeaturesSkeleton
} from '../components/Skeleton';
import '../styles/home.css';

const MainCategories = lazy(() => import('../components/MainCategories'));
const FeaturedProducts = lazy(() => import('../components/FeaturedProducts'));
const NewArrivals = lazy(() => import('../components/NewArrivals'));
const SectionsRenderer = lazy(() => import('../components/SectionsRenderer'));
const FeaturesSection = lazy(() => import('../components/FeaturesSection'));
const Testimonials = lazy(() => import('../components/Testimonials'));

const Section = ({ minHeight, fallback, children, rootMargin }) => (
  <DeferredSection minHeight={minHeight} fallback={fallback} rootMargin={rootMargin}>
    <Suspense fallback={fallback}>{children}</Suspense>
  </DeferredSection>
);

export default function Home() {
  return (
    <div>
      <HeroSlider />
      <Section minHeight={220} fallback={<CategorySkeleton />}>
        <MainCategories />
      </Section>
      <Section minHeight={620} fallback={<section className="container py-5"><ProductGridSkeleton count={4} /></section>}>
        <FeaturedProducts limit={4} />
      </Section>
      <Section minHeight={620} fallback={<section className="container py-5"><ProductGridSkeleton count={4} /></section>}>
        <NewArrivals limit={4} />
      </Section>
      <Section minHeight={700} fallback={<><SectionSkeleton /><SectionSkeleton /></>}>
        <SectionsRenderer />
      </Section>
      <Section minHeight={220} fallback={<FeaturesSkeleton />}>
        <FeaturesSection />
      </Section>
      <Section minHeight={360} fallback={null} rootMargin="200px 0px">
        <Testimonials />
      </Section>
    </div>
  );
}
